<template>
  <v-form ref="form">
    <v-row class="mt-7 no-print">
      <v-col cols="1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              :color="isTableView ? 'secondary' : undefined"
              size="25"
              v-on="on"
              class="pr-3"
              @click="toggleBarsSelection"
            >
              fa fa-bars
            </v-icon>
          </template>
          <span>Tabela</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              :color="isCardsView ? 'secondary' : undefined"
              size="25"
              v-on="on"
              class="pr-1"
              @click="toggleCardSelection"
            >
              fa fa-th
            </v-icon>
          </template>
          <span>Cards</span>
        </v-tooltip>
      </v-col>
      <v-col class="d-flex containerSwitch" v-if="isCardsView == true">
        <label class="mr-3">Cobertura básica: </label>
        <label>
          <input type="radio" value="granizo" v-model="filtroSelecionado" />
          Granizo
        </label>
        <label class="ml-3">
          <input
            type="radio"
            value="granizo_geada"
            v-model="filtroSelecionado"
          />
          Granizo e Geada
        </label>
      </v-col>
    </v-row>
    <v-row v-if="isTableView == true">
      <v-col cols="12" class="mt-6 mb-4">
        <h3 class="black--text mb-4">Seguro Cafezal</h3>
        <v-data-table
          :headers="headerCafezal"
          :items="formCost.quotationCostsCafezal"
          no-data-text="Nenhuma Cotação foi encontrada"
          loading-text="Carregando Cotações..."
          :options.sync="options"
          :server-items-length="formCost.quotationCostsCafezal.length"
          class="quotation-table base__datatable cafezal reduced-visibility"
          @click:row="openPaymentTable"
          item-key="item.index"
          :footer-props="{ 'items-per-page-options': [25, 50, 100, 250, 500] }"
          :hide-default-footer="true"
          :hide-default-header="true"
        >
          <template v-slot:[`item.index`]="{ item }">
            {{ "1." + (formCost.quotationCostsCafezal.indexOf(item) + 1) }}
          </template>
          <template #header="{ }">
            <thead class="v-data-table-header">
              <tr>
                <th
                  v-for="(h, index) in headerCafezal.filter(h => !h.subtitle)"
                  :key="index"
                  :width="h.width"
                  :rowspan="h.extracolspan ? 1 : 2"
                  :colspan="h.extracolspan ? 4 : 1"
                  class="text-center"
                  v-bind:class="{ coverage: h.extracolspan }"
                >
                  <span v-if="!h.extracolspan">
                    {{ h.text }}
                  </span>
                  <span v-else-if="h.extracolspan">
                    Coberturas
                  </span>
                </th>
              </tr>
              <tr>
                <th
                  v-for="(h, index) in headerCafezal.filter(
                    h => h.subtitle || h.extracolspan
                  )"
                  :key="index"
                  class="subtitle"
                >
                  <span>
                    {{ h.text }}
                  </span>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:[`item.area_segurada`]="{ item }">
            {{ asNumberString(item.area_segurada) }}
          </template>
          <template v-slot:[`item.valor_planta`]="{ item }">
            {{ asNumberString(item.valor_planta) }}
          </template>
          <template v-slot:[`item.granizo`]="{ item }">
            {{ item.granizo > 0 ? asNumberString(item.granizo) : "-" }}
          </template>
          <template v-slot:[`item.granizo_geada`]="{ item }">
            {{
              item.granizo_geada > 0 ? asNumberString(item.granizo_geada) : "-"
            }}
          </template>
          <template v-slot:[`item.perda_producao_futura`]="{ item }">
            {{ asNumberString(item.perda_producao_futura) }}
          </template>
          <template v-slot:[`item.tratamento_fitossanitario`]="{ item }">
            {{ asNumberString(item.tratamento_fitossanitario) }}
          </template>
          <template v-slot:[`item.premio_total`]="{ item }">
            {{ asNumberString(item.premio_total) }}
          </template>
          <template v-slot:[`item.subvencao_federal`]="{ item }">
            {{ asNumberString(item.subvencao_federal) }}
          </template>
          <template v-slot:[`item.subvencao_estadual`]="{ item }">
            {{ asNumberString(item.subvencao_estadual) }}
          </template>
          <template v-slot:[`item.premio_segurado`]="{ item }">
            {{ asNumberString(item.premio_segurado) }}
          </template>
          <template v-slot:[`item.investimento`]="{ item }">
            {{ asNumberString(item.investimento) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="isCardsView == true">
      <template>
        <v-col
          v-for="(item, index) in itemsFiltrados"
          :key="'cafezal-' + index"
          cols="12"
          md="4"
          class="containerCard"
        >
          <QuotationCostsCardCafezal
            ref="cardCafezal"
            :item="item"
            :index="getCardIndex(index)"
            @open-payment="openPayment"
            class="cardCafezal"
          />
        </v-col>
      </template>
    </v-row>
    <v-row v-if="currentQuotation.cancelada_em == null">
      <v-col
        cols="12"
        class="deadline-emission-type__disclaimer pa-4 mt-9 mb-3 no-print"
      >
        <img src="@/assets/ic_warning.svg" class="px-1" />
        <label class="primary--text caption mb-0">
          As cotações dispostas nesta página são uma prévia.
          <a @click="imprimir()" style="text-decoration: underline black"
            >Faça o download</a
          >
          para acessar a proposta completa e suas condições.
        </label>
      </v-col>
    </v-row>
    <v-dialog
      v-if="currentQuotation.cancelada_em == null && showPayment"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="showPayment"
      width="700px"
    >
      <v-row class="white px-6 py-8">
        <v-col cols="12">
          <p class="font-weight-bold primary--text form__title">
            Informações de Pagamento
          </p>
        </v-col>
        <v-row>
          <v-col md="5" class="pr-0 pr-md-5 pb-3">
            <BaseFormSelect
              id-element="tipoPos"
              placeholder="Escolher"
              label-text="Tipo POS"
              :items="paymentConditions"
              v-model="tipoPosEscolhido"
              item-text="nome"
              item-value="id"
              required
              :rules="[requiredInput]"
              :return-object="true"
              @change="onChangeTipoPos"
              :readonly="isReadonlyTipoPos"
            />
          </v-col>
        </v-row>
        <v-spacer />
        <v-row v-if="tipoPosEscolhido">
          <v-col md="4" class="pr-0 pr-md-5">
            <BaseMoney
              id-element="total"
              placeholder=""
              v-model="form.selectedCost.premio_segurado"
              label-text="Valor do prêmio"
              disabled
            />
          </v-col>
          <v-col md="3" class="pr-0 pr-md-5">
            <BaseFormSelect
              id-element="paymentForm"
              placeholder=""
              :items="paymentForm"
              v-model="form.avista_parcelado"
              label-text="Forma Pagamento"
              item-text="name"
              item-value="id"
              :return-object="true"
              required
              :rules="[requiredInput]"
              :readonly="paymentFormAvista"
              @change="onChangeFormaPagamento"
            />
          </v-col>
          <v-col md="5" class="pr-0">
            <BaseFormSelect
              id-element="payments"
              placeholder=""
              v-model="form.forma_pagamento"
              label-text="Número de Parcelas"
              :items="getPayments"
              item-text="name"
              item-value="id"
              :return-object="true"
              required
              :rules="[requiredInput]"
              :readonly="paymentFormAvista"
            />
          </v-col>
        </v-row>
      </v-row>
      <v-row cols="12" class="white d-flex justify-end">
        <v-col cols="2" class="mb-6">
          <BaseButton
            v-html="'Cancelar'"
            class="cancelButtonPayment"
            @click="closeModalPayment()"
          />
        </v-col>
        <v-col cols="2" class="mb-6">
          <BaseButton
            v-html="'Próximo'"
            class="white--text secondary"
            @click="openModal()"
          />
        </v-col>
      </v-row>
    </v-dialog>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="showModal"
      v-if="showModal"
    >
      <QuotationCafezalModal
        :selectedItem="getCustoEscolhidoCompleto"
        :formInsured="formInsured"
        :formCost="formCost"
        :formProduct="formProduct"
        :formRisk="formRisk"
        :paymentForm="form.forma_pagamento"
        :currentQuotation="currentQuotation"
        @accept="redirectToHiring"
        @cancel="closeModal"
      />
    </v-dialog>
    <v-row
      class="d-flex justify-end"
      v-if="currentQuotation.cancelada_em == null"
    >
      <v-col cols="3" class="mt-2 mb-8">
        <BaseButton
          v-html="'Imprimir'"
          class="white--text secondary no-print"
          width="100%"
          @click="imprimir()"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "Id", value: "index", sortable: false, width: "10px" },
  {
    text: "Seguradora",
    value: "seguradora.nome",
    sortable: false,
    width: "90px"
  },
  { text: "Área Segurada (ha)", value: "area_segurada", sortable: false },
  { text: "Valor da Planta (R$)", value: "valor_planta", sortable: false },
  {
    text: "Granizo (R$)",
    value: "granizo",
    sortable: false,
    extracolspan: true
  },
  {
    text: "Granizo e Geada  (R$)",
    value: "granizo_geada",
    sortable: false,
    subtitle: true
  },
  {
    text: "Perda Produção Futura (R$)",
    value: "perda_producao_futura",
    sortable: false,
    subtitle: true,
    width: "80px"
  },
  {
    text: "Tratamento Fitossanitário (R$)",
    value: "tratamento_fitossanitario",
    sortable: false,
    subtitle: true
  },
  {
    text: "POS",
    value: "tipo_pos.nome",
    sortable: false
  },
  { text: "Prêmio Total (R$)", value: "premio_total", sortable: false },
  {
    text: "Subvenção Federal (R$)",
    value: "subvencao_federal",
    sortable: false
  },
  {
    text: "Subvenção Estadual (R$)",
    value: "subvencao_estadual",
    sortable: false
  },
  { text: "Prêmio Segurado (R$)", value: "premio_segurado", sortable: false },
  { text: "Investimento (R$/ha)", value: "investimento", sortable: false }
];
const colorByStatus = [
  { color: "pink", status: "cancelada" },
  { color: "blue", status: "apolice_emitida" },
  { color: "light-blue", status: "aguardando_emissao_minuta" },
  { color: "light-blue", status: "aguardando_analise_minuta" },
  { color: "yellow", status: "em_andamento" }
];

const DEFAULT_STATUS = { color: "yellow" };

// Objeto criado para simular valores vindos da API
const TIPO_POS = [
  {
    id: "normal",
    nome: "Normal"
  },
  {
    id: "reduzida",
    nome: "Reduzida"
  }
];

const defaultPaymentForm = [
  {
    id: "avista",
    name: "À vista"
  },
  {
    id: "parcelado",
    name: "Parcelado"
  }
];

import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import QuotationCafezalModal from "../views/QuotationCafezalModal.vue";
import QuotationCostsCardCafezal from "./QuotationCostsCardCafezal.vue";
export default {
  components: {
    QuotationCafezalModal,
    QuotationCostsCardCafezal
  },
  data() {
    return {
      headerCafezal: tableHeaders,
      listColorByStatus: colorByStatus,
      formatExpirationDate,
      maskDate,
      timeout: null,
      dateTermValid,
      formatDDMMYYYYToIsoDate,
      initializeFilter: false,
      currentTab: 1,
      requiredInput,
      asNumberString,
      showModal: false,
      showPayment: false,
      paymentForm: defaultPaymentForm,
      payments: [],
      isTableView: false,
      isCardsView: true,
      isGranizo: true,
      dataCard: [],
      isReadonlyTipoPos: false,
      paymentConditions: TIPO_POS,
      tipoPosEscolhido: null,
      filtroSelecionado: "granizo"
    };
  },
  props: {
    form: {
      modalOpen: false,
      selectedItem: {}
    },
    formInsured: {
      type: Object
    },
    formCost: {
      type: Object
    },
    formProduct: {
      type: Object
    },
    formRisk: {
      type: Object
    }
  },
  mixins: [LoadingRequest, CommonPayload, QuotationMixin],
  created() {
    this.loadCosts();
  },
  computed: {
    ...mapState("quotation", [
      "statusCurrentQuotation",
      "infoCostQuotation",
      "currentQuotationAgro",
      "listQuotationCostsAgro",
      "currentQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"]),
    itemsFiltrados() {
      if (this.filtroSelecionado === "granizo_geada") {
        return this.dataCard.filter(item => item.granizo_geada > 0);
      } else {
        return this.dataCard.filter(item => item.granizo > 0);
      }
    },
    getIsGranizo() {
      return this.filtroSelecionado === "granizo";
    },
    getPayments() {
      let list = this.payments;
      if (this.form.avista_parcelado?.id === "avista") {
        list = this.payments.filter(x => x.id == "1");
      } else if (this.form.avista_parcelado?.id === "parcelado") {
        list = this.payments.filter(x => x.id != "1");
      }
      return list;
    },
    paymentFormAvista() {
      return this.form.selectedCost.paymentForm.id == "1" ? true : false;
    },
    getCustoEscolhidoCompleto() {
      return this.formCost.quotationCostsCafezal.find(
        x => x.id == this.form.selectedCost.id
      );
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestStatusCurrentQuotation",
      "requestListQuotationCostsAgro",
      "requestCurrentQuotation"
    ]),
    loadCosts() {
      let cards = [...new Set(this.formCost.quotationCostsCafezal.map(x => x))]
        .map(x => {
          let cost_normal =
            this.formCost.quotationCostsCafezal
              .filter(
                d =>
                  d.seguradora.id == x.seguradora.id &&
                  d.area_segurada == x.area_segurada &&
                  d.valor_planta == x.valor_planta &&
                  d.granizo == x.granizo &&
                  d.granizo_geada == x.granizo_geada &&
                  d.perda_producao_futura == x.perda_producao_futura &&
                  d.tratamento_fitossanitario == x.tratamento_fitossanitario &&
                  d.tipo_pos.id == "normal"
              )
              .map(u => u)[0] ?? null;
          let cost_reduzida =
            this.formCost.quotationCostsCafezal
              .filter(
                d =>
                  d.seguradora.id == x.seguradora.id &&
                  d.area_segurada == x.area_segurada &&
                  d.valor_planta == x.valor_planta &&
                  d.granizo == x.granizo &&
                  d.granizo_geada == x.granizo_geada &&
                  d.perda_producao_futura == x.perda_producao_futura &&
                  d.tratamento_fitossanitario == x.tratamento_fitossanitario &&
                  d.tipo_pos.id == "reduzida"
              )
              .map(u => u)[0] ?? null;
          return {
            seguradora: x.seguradora,
            area_segurada: x.area_segurada,
            valor_planta: x.valor_planta,
            granizo_geada: x.granizo_geada,
            granizo: x.granizo,
            perda_producao_futura: x.perda_producao_futura,
            tratamento_fitossanitario: x.tratamento_fitossanitario,
            pos_reduzido: {
              id: cost_reduzida?.id ?? null,
              premio_total: cost_reduzida?.premio_total,
              subvencao_federal: cost_reduzida?.subvencao_federal,
              subvencao_estadual: cost_reduzida?.subvencao_estadual,
              investimento: cost_reduzida?.investimento,
              premio_segurado: cost_reduzida?.premio_segurado,
              paymentForm: cost_reduzida?.paymentForm
            },
            pos_normal: {
              id: cost_normal?.id ?? null,
              premio_total: cost_normal?.premio_total,
              subvencao_federal: cost_normal?.subvencao_federal,
              subvencao_estadual: cost_normal?.subvencao_estadual,
              investimento: cost_normal?.investimento,
              premio_segurado: cost_normal?.premio_segurado,
              paymentForm: cost_normal?.paymentForm
            }
          };
        })
        .sort((a, b) => a.granizo_geada > b.granizo_geada);

      this.dataCard = [];
      cards.forEach(card => {
        if (
          this.dataCard.filter(
            x =>
              x.pos_normal?.id == card.pos_normal?.id &&
              x.pos_reduzido?.id == card.pos_reduzido?.id
          ).length == 0
        ) {
          this.dataCard.push(card);
        }
      });
    },
    getCardIndex(index) {
      // gambeta das brava, isso só existe para poder dar sequencia nos ids qdo chavear o tipo de cobertura
      let totalGranizo = this.dataCard.filter(item => item.granizo > 0).length;
      if (this.filtroSelecionado === "granizo_geada") {
        return totalGranizo + index;
      }
      return index;
    },
    loadPayments() {
      if (this.form.selectedCost == null) return;

      this.payments = [];
      for (let i = 1; i <= Number(this.form.selectedCost.paymentForm.id); i++) {
        this.payments.push({
          id: i,
          name:
            i +
            "x R$ " +
            asNumberString(this.form.selectedCost.premio_segurado / i)
        });
      }
    },
    filtrarItens(tipoFiltro, ativo) {
      if (ativo) {
        this.filtroSelecionado = tipoFiltro;
      } else {
        this.filtroSelecionado = null;
      }
    },
    borderColor(item) {
      const status =
        this.listColorByStatus.find(x => x.status == item.id) || DEFAULT_STATUS;
      return `quotation-table__border-${status.color}`;
    },
    onChangeFormaPagamento() {
      this.form.forma_pagamento = this.getPayments[this.getPayments.length - 1];
    },
    onChangeTipoPos() {
      this.form.selectedCost = null;

      if (this.tipoPosEscolhido?.id == "normal") {
        this.form.selectedCost = this.form.selectedCard.pos_normal;
      }
      if (this.tipoPosEscolhido?.id == "reduzida") {
        this.form.selectedCost = this.form.selectedCard.pos_reduzido;
      }

      this.loadPayments();
      this.setPaymentForm();
      this.onChangeFormaPagamento();
    },
    setPaymentForm() {
      this.form.avista_parcelado = this.paymentForm.find(x => x.id == "avista");
      if (Number(this.form.selectedCost?.paymentForm.id) > 1) {
        this.form.avista_parcelado = this.paymentForm.find(
          x => x.id == "parcelado"
        );
      }
    },
    closeModalPayment() {
      this.showPayment = false;
    },
    openModal() {
      if (!this.$refs.form.validate()) return;
      this.showPayment = false;
      this.showModal = true;
    },
    openPaymentTable(item) {
      this.isReadonlyTipoPos = true;
      let cardCost = this.dataCard.find(
        x => x.pos_reduzido.id == item.id || x.pos_normal.id == item.id
      );

      this.openPayment(cardCost, item.tipo_pos);
    },
    openPayment(item, tipoPos) {
      this.form.selectedCost = null;
      this.form.selectedCard = item;
      if (tipoPos == null) this.isReadonlyTipoPos = false;
      this.tipoPosEscolhido = tipoPos;
      this.setTipoPos();

      this.showModal = false;
      this.showPayment = true;
    },
    setTipoPos() {
      if (this.form.selectedCard.pos_normal?.id == null) {
        this.tipoPosEscolhido = this.paymentConditions[1];
        this.isReadonlyTipoPos = true;
      }

      if (this.form.selectedCard.pos_reduzido?.id == null) {
        this.tipoPosEscolhido = this.paymentConditions[0];
        this.isReadonlyTipoPos = true;
      }
      this.onChangeTipoPos();
    },
    closeModal() {
      this.showModal = false;
    },
    redirectToHiring() {
      this.$emit("submit", this.form);
    },
    async fetchStatusQuotation() {
      await this.requestStatusCurrentQuotation(this.$route.params.id);
    },
    imprimir() {
      const item = this.formCost.numero_cotacao;
      this.$router.push({
        name: "quotation agro",
        params: {
          id: item,
          isTableView: this.isTableView,
          isGranizo: this.isGranizo
        }
      });
    },
    toggleBarsSelection() {
      this.isTableView = !this.isTableView;
      if (this.isTableView) {
        this.isCardsView = false;
      }
    },
    toggleCardSelection() {
      this.isCardsView = !this.isCardsView;
      if (this.isCardsView) {
        this.isTableView = false;
      }
    }
  },
  watch: {
    filtroSelecionado(newValue) {
      this.isGranizo = newValue === "granizo";
    }
  }
};
</script>
<style lang="sass">
.quotation-table.cafezal
  table
    table-layout: fixed
    width: 97% !important
  tbody tr
    cursor: pointer
.base__datatable.v-data-table.theme--light.cafezal
  thead tr th
    font-size: 10px
    text-align: center
    padding: 6px 8px
  tbody tr td
    text-align: center !important
    font-size: 11px !important
  .coverage
    padding: 2px
    font-size: 10px
    height: 24px
    background-color: #EBEEF2 !important
  .subtitle
    margin: 0px 0px
    padding: 0px 1px
    text-align: center
    font-size: 9px
.deadline-emission-type__
  &disclaimer
    border-radius: 4px
    background-color: #FFC55F
  &type-files
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    background-color: #FFFFFF !important
.reduced-visibility
  tbody tr:hover
    opacity: 0.8
  tbody tr td
    cursor: pointer !important
.containerCard
  display: flex
  flex-wrap: wrap
.containerSwitch
  padding-top: 4px
.textSwitch
  margin-left: -10px
.cancelButtonPayment
  background-color: white !important
  border: 1px solid black !important
@media print
  .no-print
    display: none
  .cardCafezal
    padding-top: 50px
    margin-bottom: 200px
    width: 310px
    height: 450px
</style>
